import React, { useState } from 'react'
import FormContainer from '../components/FormContainer'
import { Form, Button } from 'react-bootstrap'
import { useDispatch, useSelector } from 'react-redux'
import { resetPasswordRequest } from '../redux/actions/userActions'

const PasswordResetScreen = () => {
  const [email, setEmail] = useState('')
  const [requested, setRequested] = useState(false)

  const dispatch = useDispatch()

  const submitHandler = (e) => {
    e.preventDefault()
    dispatch(resetPasswordRequest(email))
    setRequested(true)
  }

  return (
    <FormContainer>
      <h1>Password Reset</h1>
      {requested ? (
        <p>
          If an account with that email exists, you’ll receive a password reset
          link shortly. Please check your inbox and junk/spam folder.
        </p>
      ) : (
        <Form onSubmit={submitHandler}>
          <Form.Group controlId='email'>
            <Form.Label>Email Address</Form.Label>
            <Form.Control
              type='email'
              placeholder='Enter email'
              onChange={(e) => setEmail(e.target.value)}
            ></Form.Control>
          </Form.Group>
          <Button type='submit' variant='primary'>
            Reset
          </Button>
        </Form>
      )}
    </FormContainer>
  )
}

export default PasswordResetScreen
